import React from "react";
import { useFieldArray } from "react-hook-form";
import Input from "../Input/Input";
import styles from "./WorkingExperience.module.css";

const WorkingExperience = ({ register, control, errors, disabled }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "workingExperience",
  });

  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        companyName: "",
        designation: "",
        description: "",
        duration: "",
      });
    }
  }, [fields, append]);

  return (
    <div>
      <div className={styles.heading}>
        <h2>Working Experience</h2>
       
      </div>
      {fields.map((item, idx) => (
        <div className={styles.grid4} key={item.id}>
          <Input
            label="Institution/Company Name"
            name={`workingExperience[${idx}].companyName`}
            register={register}
            errors={errors}
            type="text"
            disabled={disabled}
          />
          <Input
            label="Role/Designation"
            name={`workingExperience[${idx}].designation`}
            register={register}
            errors={errors}
            type="text"
            disabled={disabled}
          />
          <Input
            label="Description"
            name={`workingExperience[${idx}].description`}
            register={register}
            errors={errors}
            type="text"
            disabled={disabled}
          />

          <Input
            label="Duration"
            name={`workingExperience[${idx}].duration`}
            register={register}
            errors={errors}
            duration
            disabled={disabled}
          />
          {idx > 0 && !disabled && (
            <button
              type="button"
              className={styles.remove}
              onClick={() => remove(idx)}
            >
              X
            </button>
          )}
        </div>
      ))}
      <div className={styles.buttonOuter}>
        <div></div>
       {!disabled && (
          <button
            type="button"
            className={styles.button}
            onClick={() =>
              append({
                companyName: "",
                designation: "",
                description: "",
                duration: "",
              })
            }
          >
            + Add More
          </button>
        )}
        </div>
    </div>
  );
};

export default WorkingExperience;
